export default "__VITE_ASSET__ImTWUoMf__"